import { useMemo } from 'react';

export function useTimeOptions() {
  const timeOptions = useMemo(() => {
    const start = 8 * 60;
    const end = 22 * 60;
    const opts: { value: string; label: string }[] = [];
    for (let t = start; t <= end; t += 15) {
      const hh = String(Math.floor(t / 60)).padStart(2, '0');
      const mm = String(t % 60).padStart(2, '0');
      const v = `${hh}:${mm}`;
      opts.push({ value: v, label: v });
    }
    return opts;
  }, []);

  const pickupTimeOptions = useMemo(() => {
    const start = 7 * 60;
    const end = 20 * 60;
    const opts: { value: string; label: string }[] = [];
    for (let t = start; t <= end; t += 15) {
      const hh = String(Math.floor(t / 60)).padStart(2, '0');
      const mm = String(t % 60).padStart(2, '0');
      const v = `${hh}:${mm}`;
      opts.push({ value: v, label: v });
    }
    return opts;
  }, []);

  return { timeOptions, pickupTimeOptions } as const;
}
